export const getBreadcrumbMenusFrag = `
    url
    options
`;
